import { Component, OnInit } from '@angular/core';
import {timeInterval} from '../time.model';


@Component({
  selector: 'impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.sass']
})
export class ImpressumComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  getTimeInterval(){
    return timeInterval;
  }

  disableGoogleAnalytic(){
    window['ga-disable-UA-168766260-1'] = true;
  }

}
